exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".truncate-td {\n  max-width: 200px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.btn-success {\n  color: #fff;\n  background-color: #8194DC;\n  border-color: #8194DC; }\n\n.btn-success:hover {\n  color: white;\n  background-color: #647FD9;\n  border: 2px solid #647FD9; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/incident-control/incident-control.component.scss
// module id = ../../../../../src/app/admin/incident-control/incident-control.component.scss
// module chunks = incident-control.module